var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.31152 2.77881H18.3115V14.7788H7.31152V2.77881ZM5.31152 2.77881H2.31152V14.7788H5.31152V2.77881ZM0.311523 2.77881C0.311523 1.67424 1.20695 0.778809 2.31152 0.778809H18.3115C19.4161 0.778809 20.3115 1.67424 20.3115 2.77881V14.7788C20.3115 15.8834 19.4161 16.7788 18.3115 16.7788H2.31152C1.20695 16.7788 0.311523 15.8834 0.311523 14.7788V2.77881Z","fill":"currentColor"}));
}

SVGIcon.defaultProps = {"width":"21","height":"17","viewBox":"0 0 21 17","fill":"none"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
